customElements.define('component-header', class documentComponentHeader extends HTMLElement {
  constructor() {
    super();

    this.hamburgerIcon = document.querySelector('.header-hamburger-button');
    this.mobileMenu = document.querySelector('component-mobile-menu');

    this.hamburgerIcon.addEventListener('click', (event) => {
      event.preventDefault();
      this.openMobileMenu();
    });

    this.settings = {
      loyaltyBaseUrl: window.theme?.loyalty?.base_url,
      loyaltyApiKey: window.theme?.loyalty?.api_key,
      customerEmail: window.theme?.customer?.email,
    };
  }

  async connectedCallback() {
    if(window.theme.loyalty?.customer) {
      await this.getCustomerLoyaltyData()
      this.updatePointsInfo();
    }
  }

  openMobileMenu() {
    this.mobileMenu.openMenu();
  }

  async getCustomerLoyaltyData() {
    try {
      let customerLoyaltyData = Number.isInteger(window.theme?.loyalty?.customer?.points) ? window.theme.loyalty.customer : null;

      if (!customerLoyaltyData) {
        const response = await fetch(`${this.settings.loyaltyBaseUrl}customer?email=${encodeURIComponent(this.settings.customerEmail)}`, {
          method: 'GET',
          headers: {
            authorization: this.settings.loyaltyApiKey
          }
        });
        if (response?.ok) {
          customerLoyaltyData = await response.json();
          if (window.theme?.loyalty) {
            window.theme.loyalty.customer = {...window.theme.loyalty.customer || {}, ...customerLoyaltyData};
          }
        } else {
          console.error('Error fetching customer data.');
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  updatePointsInfo() {
    const points = window.theme.loyalty?.customer?.points;
    if (points) {
      if (this.querySelector('.js-header-account-customer-points')) {
        this.querySelector('.js-header-account-customer-points').innerText = `| You have ${points} points!`;
      }
    }
  }
});
